import React, { useRef, useState } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import supabase from '../config/supabaseClient';
import { useAuth } from '../context/AuthContext';
import HCaptcha from '@hcaptcha/react-hcaptcha';

const LoginToken = () => {
  const env = process.env;
  const sitekey = env.REACT_APP_HCAPTCHA_SITE_KEY;

  const { setToken } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [tokenCaptcha, setTokenCaptcha] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const captchaRef = useRef(null);
  const navigate = useNavigate();

  const handleCaptchaVerify = (token) => {
    setTokenCaptcha(token);
  };

  const getUserIP = async () => {
    const res = await fetch('https://api.ipify.org?format=json');
    const data = await res.json();
    return data.ip;
  };

  const logAttempt = async (email, success) => {
    const ip = await getUserIP();

    await supabase.from('login_attempts').insert({
      email,
      success,
      ip
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const { data, error } = await supabase.auth.signInWithPassword({
        email,
        password
      });
      const success = !error;
      await logAttempt(email, success);
      if (error) throw error;
      setToken(data.session.access_token);
      localStorage.setItem('token', data.session.access_token);

      navigate('/');
    } catch (err) {
      setError('Correo o contraseña incorrectos');
      setPassword('');
    } finally {
      if (captchaRef.current) {
        captchaRef.current.resetCaptcha();
        setTokenCaptcha(null);
      }
      setLoading(false);
    }
  };

  const isFormValid = () => {
    return email !== '' && password !== '' && tokenCaptcha !== null;
  };

  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <div className="card shadow p-4" style={{ width: '100%', maxWidth: '400px' }}>
        <h3 className="text-center mb-4">Iniciar sesión</h3>
        <form onSubmit={handleSubmit} className='w-100'>
          <div className="mb-3">
            <label className="form-label">Correo electrónico</label>
            <input
              type="email"
              className="form-control"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="correo@ejemplo.com"
              required
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Contraseña</label>
            <input
              type="password"
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </div>

          <div className="mb-3 d-flex justify-content-center">
            <HCaptcha
              sitekey={sitekey}
              onVerify={handleCaptchaVerify}
              ref={captchaRef}
            />
          </div>

          {error && <div className="alert alert-danger py-2">{error}</div>}
          <button type="submit" className="btn btn-primary w-100" disabled={loading || !isFormValid()}>
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" />
                Iniciando...
              </>
            ) : (
              'Entrar'
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

const Login = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={<LoginToken />}
      />
    </Routes>
  );
};

export default Login;
